import { fade } from "@material-ui/core/styles";

export const useStyles = (theme) => ({
  title: {
    display: "flex",
    fontSize: 20,
    justifyContent: "flex-start",
    flexGrow: 1,
  },
  root: {
    minHeight: "100vh",
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  search: {
    width: "100%",
    display: "flex",
    flexGrow: 1,
    position: "relative",
    marginRight: theme.spacing(30),
    marginLeft: 0,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.25),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  inputRoot: {
    color: "inherit",
    [theme.breakpoints.down("sm")]: {
      height: 100,
    },
  },
  inputInput: {
    padding: 5,
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(1)}px)`,
    transition: theme.transitions.create("width"),
    width: "70%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
  buttonStyle: {
    display: "flex",
    alignItems: "center",
    variant: "contained",
    backgroundColor: "#eee !important",
    outlineColor: "#eee !important",
    height: 25,
  },
  loadingStyle: {
    minheight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignitems: "center",
  },
});
